import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.analysisObject;

export default class AnalysisObject extends Model {
  static entity = `${ name }`;
  static primaryKey = 'trial_id';

  static fields() {
    return {
      trial_id: this.attr(null),
      analyses: this.attr({}),
      products: this.attr({}),
      custom_analyses: this.attr({}),
      custom_ingredients: this.attr({}),
    };
  }

  static methodConf = {
    http: {
      url: '/modules/analysis',
    },
    methods: {
      $get: {
        name: 'get',
        http: {
          url: '/:id/object',
          method: 'get',
        },
      },
      $create: {
        name: 'create',
        http: {
          url: '/:id/object',
          method: 'put',
        },
      },
      $update: {
        name: 'update',
        http: {
          url: '/:id/object',
          method: 'patch',
        },
      },
    },
  };
}
